import { Navigate } from 'react-router-dom';

/**
 * Route guard for developer-only surfaces (sibling to ModuleRoute, which
 * gates on a user's enabled modules instead).
 *
 * Renders `children` only under Vite's dev server, else redirects home —
 * the same fallback ModuleRoute uses for a module the user hasn't enabled.
 *
 * `import.meta.env.DEV` is a Vite build-time constant: a production build
 * (`npm run build`) inlines it as the literal `false`, so this branch is
 * dead-code-eliminated there. A curious production user hitting the guarded
 * URL directly is redirected before the guarded page's lazy chunk is ever
 * requested — currently used for /design-system, a component/token showcase
 * with real value to whoever is building UI here but none to an end user.
 */
export default function DevOnlyRoute({ children }) {
    if (!import.meta.env.DEV) {
        return <Navigate to="/" replace />;
    }
    return children;
}
